import { useState } from "react";
import { authenticatedFetch } from '@/services/auth/authenticatedFetch.js';
import {useAppSelector} from '@/store/hooks.js';

const useSimulatePayslipImport = () => {
    const currentUser = useAppSelector((state) => state.auth.currentUser);
    const [loadingPayslipBookImport, setLoadingPayslipBookImport] = useState(false);
    const [errorPayslipBookImport, setErrorPayslipBookImport] = useState(null);

    const simulatePayslipImport = async (file, paymentDate) => {
        const formData = new FormData();
        formData.append("payslipFile", file);
        formData.append("paymentDate", paymentDate);
        formData.append("companyUuid", currentUser.company.uuid); // Ajout de companyUuid

        console.log("Starting payslip file import...");
        setLoadingPayslipBookImport(true);
        setErrorPayslipBookImport(null);

        try {
            console.log("Sending request to simulate payslip file import...");
            const response = await authenticatedFetch(window.ENV.BACKEND_URL + '/api/secured/admin/payslip/simulatePayslipFileImport', {
                method: 'POST',
                body: formData,
            });

            if (!response.ok) {
                const errorText = await response.text();
                console.error("Error response received:", errorText);
                throw new Error(errorText || 'Error simulating payslip file import');
            }

            console.log("Response received successfully. Parsing data...");
            const responseData = await response.json();

            // Extraction des données nécessaires
            const users = responseData.users.map(({ user, payslips }) => ({
                uuid: user.uuid,
                firstname: user.firstname,
                lastname: user.lastname,
                trigram: user.trigram,
                fiduciaryId: user.fiduciaryId,
                payslips,
            }));

            // Extract unknown payslips
            const unknownPayslips = responseData.unknownPayslips.map((payslip) => ({
                payslipFileUuid: payslip.payslipFileUuid,
                consultantUuid: payslip.consultantUuid,
                period: payslip.period,
                paymentDate: payslip.paymentDate,
                currency: payslip.currency,
                grossSalary: payslip.grossSalary,
                netSalary: payslip.netSalary,
                taxes: payslip.taxes,
                employerContributions: payslip.employerContributions,
                employeeContributions: payslip.employeeContributions,
                comment: payslip.comment,
                bonus: payslip.bonus,
            }));

            console.log("Parsed unknown payslips data:", unknownPayslips);

            return { data: { users, unknownPayslips }, error: null };
        } catch (err) {
            console.error("Error during payslip file import:", err.message);
            setErrorPayslipBookImport(err.message);
            return { data: null, error: err.message };
        } finally {
            console.log("Payslip file import process completed.");
            setLoadingPayslipBookImport(false);
        }
    };

    return { simulatePayslipImport, loadingPayslipBookImport, errorPayslipBookImport, loading: loadingPayslipBookImport, error: errorPayslipBookImport };
};

export { useSimulatePayslipImport };
